// Genera un UUID de idempotencia para cada envío de formulario.
// Debe generarse UNA sola vez por formulario y reutilizarse en todos los
// reintentos (envío directo + cola offline), para que el servidor reconozca
// los reenvíos por señal intermitente y no cree formularios duplicados.
export function generarClientFormId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Fallback para WebViews Android antiguos sin crypto.randomUUID
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}
